<script setup lang="ts">
import {useTenantConfigStore} from '@/shared/stores/tenantConfig.store';

const tenantConfigStore = useTenantConfigStore();
</script>

<template>
   <div class="nf-layout">
      <div class="nf-layout__content">
         <img
            v-if="tenantConfigStore.logoUrl"
            :src="tenantConfigStore.logoUrl"
            alt=""
            class="nf-layout__logo"
         />
         <slot />
      </div>
   </div>
</template>

<style scoped lang="scss">
.nf-layout {
   display: flex;
   align-items: center;
   justify-content: center;
   min-height: 100dvh;
   padding: 24px;
   background: #f5f7fa;

   &__content {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      max-width: 480px;
   }

   &__logo {
      max-height: 48px;
      margin-bottom: 32px;
   }
}
</style>
